import bn from '../../utils/bemnames';
import React from 'react';
import {EventStatus, IMaxOdd, IMaxOddsObject, oddsFormats} from '../../utils/types';
import OddsButtonWithProviderLogo from '../OddsButtonWithProviderLogo';
import {IHeaderProvider, IOddsComparisonTableEvent} from '../OddsComparisonTable';

interface IProps {
  oddsGroup: IMaxOdd[]|IMaxOddsObject;
  event: IOddsComparisonTableEvent;
  headerProviders: IHeaderProvider[];
  oddsFormat?: oddsFormats;
  outLinkFolder?: string|null;
  logoType: string
}

const bem = bn.create('odds-comp');

const OddsGroup: React.FC<IProps> = (
  {oddsGroup, event, headerProviders, oddsFormat, outLinkFolder, logoType}
) => {
  return (
    <>
      <div className={bem.e('odds-wrapper')}>
        {oddsGroup.map((maxOddsPerEvent:any, index:any) => {

          if (!maxOddsPerEvent.odds || !maxOddsPerEvent.providerId) {
            return (
              <div key={maxOddsPerEvent + ' - ' + index} className={bem.e('odds-box-wrp')}/>
            );
          }

          const provider = headerProviders.filter(headerProvider => headerProvider.id === maxOddsPerEvent.providerId)[0];
          const providerSlug = headerProviders.filter(headerProvider => headerProvider.id === maxOddsPerEvent.providerId)[0]?.slug;

          // add odds drifting or shortening arrows if this is a live game
          let prevOdds = 0;
          if (maxOddsPerEvent.providerId && event.providerId2Odds[maxOddsPerEvent.providerId]) {
            prevOdds = event.providerId2Odds[maxOddsPerEvent.providerId][index]?.oddsPrev;
          }
          let oddsChangeStatus = '';
          if (event.status === EventStatus.Inprogress) {
            oddsChangeStatus = prevOdds ?
              maxOddsPerEvent.odds - prevOdds > 0 ?
                'drifting' :
                maxOddsPerEvent.odds - prevOdds < 0 ?
                  'shortening' :
                  '' :
              '';
          }

          return (
            <div key={maxOddsPerEvent + ' - ' + index} className={bem.e('odds-box-wrp')}>
              <OddsButtonWithProviderLogo
                width={60}
                odds={maxOddsPerEvent.odds}
                oddsFormat={oddsFormat}
                provider={provider}
                providerSlug={providerSlug}
                outLinkFolder={outLinkFolder}
                oddsChangeStatus={oddsChangeStatus}
                logoType={logoType}
              />
              <span className={bem.e('odds-box-provider-name')}><b>{provider?.name}</b></span>
            </div>
          )
        })}
      </div>
    </>
  )
}

export default OddsGroup;
